module.exports = "/_next/static/images/PowerfulIntegrations@2x-2378a704de44e4ca256a52f71bbde46d.webp";